import { Box, Breadcrumbs, Icon, styled, Tooltip } from "@mui/material";
import { Link } from "react-router-dom";

import { useAppSelector } from "~/hooks/reduxHooks";

const PageBreadcrumbs = () => {
	const pageBreadcrumb = useAppSelector((state) => state.layout.pageBreadcrumb);
	const pageIdentifier = useAppSelector((state) => state.layout.pageIdentifier);
	const isWideScreen = useAppSelector((state) => state.layout.isWideScreen);

	const StyledLink = styled(Link)`
		text-decoration: none;
		color: inherit;
		font-size: 0.9rem;
		&:focus,
		&:visited,
		&:link,
		&:hover,
		&:active {
			text-decoration: underline;
		},
		&:hover{
			text-shadow: 0 0 1px; 
		},
	`;
	const StyledBox = styled(Box)`
		text-decoration: none;
		color: inherit;
		font-size: 0.9rem;
	`;

	if (!isWideScreen) {
		return null;
	}

	return (
		<Breadcrumbs
			aria-label="breadcrumb"
			separator={<Icon>chevron_right</Icon>}
			sx={{
				"& .MuiBreadcrumbs-ol": { flexWrap: "nowrap" },
				"& .MuiBreadcrumbs-ol > li:last-of-type": { minWidth: 0 },
				minWidth: 0
			}}
		>
			{pageBreadcrumb?.map((item, i) => {
				const isLast = i === pageBreadcrumb.length - 1;
				if (isLast) {
					const label = pageIdentifier ? `${item.label} : ${pageIdentifier}` : item.label;
					return (
						<Tooltip key={i} title={label}>
							<StyledBox
								className={i === 0 && !pageIdentifier ? "silverfern-font-breadcrumb" : undefined}
								sx={{ display: "block", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}
							>
								{label}
							</StyledBox>
						</Tooltip>
					);
				}
				if (!item.link) {
					return (
						<StyledBox className={i === 0 ? "silverfern-font-breadcrumb" : undefined} key={i}>
							{item.label}
						</StyledBox>
					);
				}
				return (
					<StyledLink key={i} to={item.link}>
						{item.label}
					</StyledLink>
				);
			})}
		</Breadcrumbs>
	);
};

export default PageBreadcrumbs;
